import React, { useEffect, useState, useRef, useMemo } from "react";
import Sidebar from "../comman/Sidebar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Grid,
  FormControl,
  InputAdornment,
  Checkbox,
  ListItemText,
  Stack,
  InputLabel,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  Pagination,
  Paper,
  PaginationItem,
  Icon,
} from "@mui/material";
import {} from "@mui/material";
import {
  USERLOG_LIST_URL,
  USERS_LIST_URL,
  USER_FILTER_LIST_URL,
} from "../../constants/ApiRoute";
import { authHeader, getLogUserRole } from "../comman/MainFunction";
import API from "../comman/API";

import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { USERS_DETAILS, USER_LOG_ROUTE } from "../../constants/RoutePath";
import { debounce } from "underscore";
import { Link, useLocation } from "react-router-dom";
import UserFilter from "../model/UseFilter";
import UserClearFilter from "../model/UserClearFilter";
import { userRole as data } from "../comman/Constant";
import CustomPageLoading from "../comman/CustomPageLoading";
import Navbar from "../comman/Navbar";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { getAlluserList } from "../../redux/action";
import moment from "moment";
import { useToast } from "../comman/CustomMessages";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import UnfoldMoreSharpIcon from "@mui/icons-material/UnfoldMoreSharp";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";

//import Checkbox from '@mui/material/Checkbox';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { PAGE_OFFSET, SORT_PARAMS } from "../../redux/action/ActionType";
import NoRecordFound from "../comman/NoRecordFound";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const filterInitial = {
  userRole: "",
  accountActive: "",
  archivedUserStatus: "",
  accountActiveYes: "",
  accountActiveNo: "",
};

const Users = () => {
  const currentPage = useSelector((r) => r.PageReducer);
  const currentSort = useSelector((r) => r.SortReducer);
  console.log("currentSort", currentSort);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const showToast = useToast();
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(0);
  const [personName, setPersonName] = React.useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [userNameList, setUserNameList] = React.useState([]);
  const [clearFlag, setClearFlag] = useState(false);
  const [clearFiltervalue, setClearFilterValue] = useState(false);
  const [usersFilter, setUsersFilter] = useState(filterInitial);
  const [search, setSearch] = React.useState("");
  console.log(search,'searchmmm')
  const [applyFilterFlag, setApplyFilterFlag] = React.useState(false);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [backButtonFilter, setBackButtonFilter] = useState(false);
  const [sortClickedTime, setSortClickedTime] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const userListSel = deCryptFun(useSelector((s) => s.AllUserReducer));
  const userList = userListSel ? JSON.parse(userListSel).data : [];
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [searchInput, setSearchInput] = useState("");

  const getLogUserRoleArray = getLogUserRole();
  var isOnlyAdmin = false;
  if (
    getLogUserRoleArray &&
    getLogUserRoleArray.length > 0 &&
    getLogUserRoleArray.includes("Admin")
  ) {
    isOnlyAdmin = true;
  }

  // const handleSortRequest = (property) => {
  //   const isAsc = orderBy === property && order === "asc";

  //   console.log("ASC -->", isAsc);
  //   console.log("order", order);
  //   console.log("orderBy", orderBy);

  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);

  //   if (order === "desc") {
  //     setOrder("");
  //     setOrderBy("");
  //   }
  //   setPage(0);
  //   setSortClickedTime(new Date().toLocaleString());
  // };

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === "asc";

    // console.log("Sort ==> ASC -->", isAsc);
    // console.log("Sort ==> order", order);
    // console.log("Sort ==> orderBy", orderBy);
    // console.log("Sort ==> property", property);
    // console.log("Sort ==> +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");

    let orderValue = isAsc ? "desc" : "asc";
    setOrder(orderValue);
    setOrderBy(property);

    dispatch({
      type: SORT_PARAMS,
      payload: { order: orderValue, orderBy: property },
    });

    if (order === "desc") {
      setOrder("");
      setOrderBy("");

      dispatch({
        type: SORT_PARAMS,
        payload: { order: "", orderBy: "" },
      });

    }

    if(orderBy != property){
      setOrder("asc");
      setOrderBy(property);

      dispatch({
        type: SORT_PARAMS,
        payload: { order: "asc", orderBy: property },
      });

    }

    setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: page,
    });
    setSortClickedTime(new Date().toLocaleString());
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };
  useEffect(() => {
    if (isInitialLoad) {
      dispatch({
        type: PAGE_OFFSET,
        payload: 0,
      });
      setIsInitialLoad(false);
    }
  }, [isInitialLoad, dispatch]);

  // const sortedList = useMemo(() => {
  //   if (orderBy) {
  //     return [...list].sort((a, b) => {
  //       if (orderBy === "CreatedDate") {
  //         const dateA = new Date(a[orderBy]).getTime();
  //         const dateB = new Date(b[orderBy]).getTime();

  //         if (order === "asc") {
  //           return dateA - dateB;
  //         } else {
  //           return dateB - dateA;
  //         }
  //       } else if (orderBy === "AccountActive") {
  //         const valueA = a[orderBy];
  //         const valueB = b[orderBy];

  //         if (order === "asc") {
  //           return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
  //         } else {
  //           return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
  //         }
  //       } else {
  //         const valueA = a[orderBy].toLowerCase();
  //         const valueB = b[orderBy].toLowerCase();

  //         if (order === "asc") {
  //           return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
  //         } else {
  //           return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
  //         }
  //       }
  //     });
  //   }
  //   return list;
  // }, [list, orderBy, order]);

  const userRoleMapping = (item) => {
    let itemSplit = item && item.split(",");
    if (itemSplit && itemSplit.length > 0) {
      return itemSplit.map((itemId) => {
        let acc = data.find((r) => r.id == itemId);
        if (acc) {
          return (
            <Chip
              sx={{ height: "26px", mt: "0px !important" }}
              key={acc.id}
              className={
                acc.role === "Admin" ? "role-chip admin" : "role-chip broker"
              }
              variant="outlined"
              label={acc.role}
            />
          );
        }
        return null; // Return null if the account is not found
      });
    }
    return null; // Return null if the input is empty or invalid
  };

  const findDuplicateUserId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.UserId)) {
        duplicates.add(obj.UserId);
      } else {
        seen.add(obj.UserId);
      }
    });

    return Array.from(duplicates);
  };

  const handleSearchOnChange = (event, newValue) => {
    setSearchInput((prev) => prev); 
    console.log(event?.target, 'targeeeeeeeee', newValue)
    if (event.target.type != "text") {
      const duplicateArray = findDuplicateUserId(newValue);
      if (duplicateArray && duplicateArray.length > 0) {
        const updatedNewArray = newValue.filter(
          (obj) => obj.UserId !== duplicateArray[0]
        );
        newValue = updatedNewArray;
      }

      const uniqueSelectedProjects = newValue.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.UserId === item.UserId)
      );
      setSelectedUsers(uniqueSelectedProjects);

      // handleSearchStateReset();

      if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
        const idsString = uniqueSelectedProjects
          .map((item) => item.UserId)
          .join(",");
        setSearch(idsString);
        setPage(0);
        filterUserSubmit(idsString, 0);
      } else {
        setSearch("");
        setPage(0);
        filterUserSubmit("empty", 0);
      }
      // setTimeout(setAttributeForTitle, 2000);
    }
    setSearchInput((prev) => prev); 
  };

  const handleSearchDeleteOnChange = (value) => {
    var arr = selectedUsers.filter((item) => item.UserId !== value);
    var uniqueSelectedProjects = arr;
    setSelectedUsers(arr);

    // handleSearchStateReset();

    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      const idsString = uniqueSelectedProjects
        .map((item) => item.UserId)
        .join(",");
      setSearch(idsString);
      setPage(0);
      filterUserSubmit(idsString, 0);
    } else {
      setSearch("");
      setPage(0);
      filterUserSubmit("empty", 0);
    }
    // setTimeout(setAttributeForTitle, 2000);
  };

  const handleSearchCheckboxOnChange = (value, isSelected) => {
    let uniqueSelectedProjects = "";
    if (isSelected) {
      var arr = selectedUsers.filter((item) => item.UserId !== value.UserId);
      uniqueSelectedProjects = arr;
      setSelectedUsers(arr);
    } else {
      const updatedProjects = [...selectedUsers, value];
      setSelectedUsers(updatedProjects);
      uniqueSelectedProjects = updatedProjects;
    }

    // handleSearchStateReset();

    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      uniqueSelectedProjects.map((item) => item.UserId);
      const idsString = uniqueSelectedProjects
        .map((item) => item.UserId)
        .join(",");
      setSearch(idsString);
      setPage(0);
      filterUserSubmit(idsString, 0);
    } else {
      setSearch("");
      setPage(0);
      filterUserSubmit("empty", 0);
    }
    setSearchInput((prev) => prev); 
    // setTimeout(setAttributeForTitle, 2000);
  };

  const handleSearchStateReset = () => {
    // setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
    //setUsersFilter(filterInitial);
  };
  useEffect(() => {
    if (currentPage) {
      setPage(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    if (currentSort) {
      setOrder(currentSort.order);
      setOrderBy(currentSort.orderBy);
    }
  }, [currentSort]);

  const getUsersList = async () => {
    let data = {
      count: count,
      offset: page,
      sort: "",
      orderBy: "",
    };

    if (order) {
      data.sort = order;
      data.orderBy = orderBy;
    }

    const config = {
      method: "GET",
      url: USER_FILTER_LIST_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };
    try {
      setLoading(true);
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setList(parsedResponse.data);
        setTotal(Math.ceil(parsedResponse.totalCount / count));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  /*
  useEffect(() => {
    getUsersList();
    dispatch(getAlluserList());
  }, []);
  */

  useEffect(() => {
    if (backButtonFilter === true) {
      if (selectedUsers && selectedUsers.length > 0) {
        let userIds = selectedUsers.map((user) => user.UserId);
        filterUserSubmit(userIds.join(","), "");
      } else {
        filterUserSubmit();
      }
      setBackButtonFilter(false);
    }
  }, [backButtonFilter]);

  useEffect(() => {
    if (localStorage.getItem("USER_PAGE_BACKBUTTON_CLICK")) {
      const USER_PAGE_FILTER = localStorage.getItem("USER_PAGE_FILTER");
      const USER_PAGE_SEARCH = localStorage.getItem("USER_PAGE_SEARCH");

      var USER_PAGE_FILTER_DEC = "";
      var USER_PAGE_SEARCH_DEC = "";

      if (USER_PAGE_FILTER) {
        USER_PAGE_FILTER_DEC = deCryptFun(USER_PAGE_FILTER);
        USER_PAGE_FILTER_DEC = USER_PAGE_FILTER
          ? JSON.parse(USER_PAGE_FILTER_DEC)
          : "";
      }
      if (USER_PAGE_SEARCH) {
        USER_PAGE_SEARCH_DEC = deCryptFun(USER_PAGE_SEARCH);
        USER_PAGE_SEARCH_DEC = USER_PAGE_SEARCH
          ? JSON.parse(USER_PAGE_SEARCH_DEC)
          : "";
      }

      if (USER_PAGE_SEARCH_DEC && USER_PAGE_SEARCH_DEC.length > 0) {
        setSelectedUsers(USER_PAGE_SEARCH_DEC);
      }

      if (USER_PAGE_FILTER_DEC) {
        setUsersFilter(USER_PAGE_FILTER_DEC);
        setApplyFilterFlag(true);
      }

      localStorage.removeItem("USER_PAGE_FILTER", "");
      localStorage.removeItem("USER_PAGE_SEARCH", "");
      localStorage.removeItem("USER_PAGE_BACKBUTTON_CLICK", "");
      setBackButtonFilter(true);
    } else {
      localStorage.removeItem("USER_PAGE_FILTER", "");
      localStorage.removeItem("USER_PAGE_SEARCH", "");
      localStorage.removeItem("USER_PAGE_BACKBUTTON_CLICK", "");
      getUsersList();
      setBackButtonFilter(false);
    }
    dispatch(getAlluserList());
  }, []);

  // useEffect(() => {
  //   delaySearch(search,page,clearFiltervalue);
  // }, [search,page,clearFiltervalue]);

  // const delaySearch = useRef(
  //   debounce((search,page,clearFiltervalue) => filterUserSubmit(search,page,clearFiltervalue))
  // ).current;

  const handleChange = (event, value) => {
    setPage(value - 1);

    console.log("value", value);

    dispatch({
      type: PAGE_OFFSET,
      payload: value - 1,
    });

    filterUserSubmit(search ? search : "", value - 1);
  };

  const handleChangeSearch = (event) => {
    const {
      target: { value },
    } = event;
    // setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
    setPersonName(value);
    setUsersFilter(filterInitial);

    if (value && value.length > 0) {
      setSearch(value.join(","));
      filterUserSubmit(value.join(","), "");
    } else {
      setSearch("");
      filterUserSubmit();
    }
  };

  const filterOpenFun = () => {
    // setSearch([]);
    // setPersonName([]);
    // setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
    setOpenFilter(!openFilter);
  };

  const filterClose = () => {
    if (!applyFilterFlag) {
      setUsersFilter(filterInitial);
    }
    setOpenFilter(false);
  };

  const applyFilterFun = () => {
    setOpenFilter(false);
    setApplyFilterFlag(true);
    setPage(0);
    // setPersonName([]);
    // filterUserSubmit(search);
    filterUserSubmit(search ? search : "", 0);
  };

  const clearFilterOpen = () => {
    setClearFlag(!clearFlag);
    //setApplyFilterFlag(false);
    setClearFilterValue(false);
  };

  const resetFilter = (value) => {
    console.log("usersFilter", usersFilter);
    setClearFlag(false);

    if (value === true) {
      setSearchInput("")
      setApplyFilterFlag(false);
      setSelectedUsers([]);
      setSearch("");
      setPage(0);
      setUsersFilter(filterInitial);
      // setPersonName([]);
      getUsersList();

      // if((search&&search.length>0)){
      // setUsersFilter(filterInitial);
      // filterUserSubmit(search);
      // }else{
      //   getUsersList()
      // }
    }
  };

  /*
  useEffect(() => {
    if (clearFiltervalue == true) {
      setUsersFilter(filterInitial);
      setPersonName([]);
      getUsersList();
    }
  }, [clearFiltervalue]);
*/
  const filterUserSubmit = async (searchInput, pageVal) => {
    let data = {
      count: count,
      offset: page,
      sort: "",
      orderBy: "",
    };

    if (typeof pageVal === "number") {
      data.offset = pageVal;
    }

    if (order) {
      data.sort = order;
      data.orderBy = orderBy;
    }

    if(selectedUsers && selectedUsers.length > 0){
      let userIds = selectedUsers.map(user => user.UserId);
      data.userId = userIds;
    }

    if (searchInput) {
      data.userId = searchInput;
      // data.offset = 0;
    }

    if (searchInput && searchInput == "empty") {
      data.userId = "";
    }

    if (usersFilter.userRole) {
      data.userRole = usersFilter.userRole;
    }

    if (usersFilter.accountActiveYes && !usersFilter.accountActiveNo) {
      data.accountActive = true;
    }

    if (!usersFilter.accountActiveYes && usersFilter.accountActiveNo) {
      data.accountActive = false;
    }

    // if (typeof usersFilter.archivedUserStatus === "boolean") {
    //   data.accountArchive = usersFilter.archivedUserStatus ? true;
    // }

    if (usersFilter.archivedUserStatus) {
      data.accountArchive = usersFilter.archivedUserStatus;
    }

    console.log("usersFilter --->", usersFilter);

    const config = {
      method: "GET",
      url: USER_FILTER_LIST_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      setLoading(true);
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setList(parsedResponse.data);
        setTotal(Math.ceil(parsedResponse.totalCount / count));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const clearProject = () => {
    // setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
    setPersonName([]);
    setUsersFilter(filterInitial);
    filterUserSubmit();
  };

  const localStorageFilter = (value) => {
    if (value) {
      if (selectedUsers && selectedUsers.length > 0) {
        localStorage.setItem(
          "USER_PAGE_SEARCH",
          enCryptFun(JSON.stringify(selectedUsers))
        );
      }

      if (applyFilterFlag) {
        localStorage.setItem(
          "USER_PAGE_FILTER",
          enCryptFun(JSON.stringify(usersFilter))
        );
      }

      dispatch({
        type: PAGE_OFFSET,
        payload: page,
      });
      
    } else {
      localStorage.removeItem("USER_PAGE_FILTER", "");
      localStorage.removeItem("USER_PAGE_SEARCH", "");
    }
  };

  useEffect(() => {
    if (sortClickedTime) {
      filterUserSubmit();
    }
  }, [sortClickedTime]);

  // const setAttributeForTitle = () => {
  //   const clearButton = document.querySelector(
  //     'button[aria-label="Clear"][title="Clear"]'
  //   );
  //   // console.log("clearButton", clearButton)
  //   if (clearButton) {
  //     clearButton.setAttribute("aria-label", "Remove All");
  //     clearButton.setAttribute("title", "Remove All");
  //   }
  // };

    useEffect(() => {
      const handlePopState = () => {
        // Perform any custom logic if needed
        console.log("Browser back button clicked");
      };
    
      // Attach the popstate event listener
      window.addEventListener("popstate", handlePopState);
    
      return () => {
        // Clean up the event listener on unmount
        window.removeEventListener("popstate", handlePopState);
      };
    }, []);

  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide= {'6'}/>

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar title="Manage Users" />
          <Box
            sx={{ pt: "31px", pl: "28px", pr: "28px" }}
            className="bg-box user-log"
          >
            <Grid container>
              <Grid sx={{ mb: "16px" }} container>
                <Grid xs={5} md={5}>

<Autocomplete
  multiple
  id="checkboxes-tags-demo"
  options={userList.sort((a, b) => {
    const nameA = `${a.FirstName} ${a.LastName}`;
    const nameB = `${b.FirstName} ${b.LastName}`;

    const firstCharA = nameA[0].toLowerCase();
    const firstCharB = nameB[0].toLowerCase();

    if (firstCharA !== firstCharB) {
      return firstCharA.localeCompare(firstCharB);
    }

    const isUpperCaseA = nameA[0] === nameA[0].toUpperCase();
    const isUpperCaseB = nameB[0] === nameB[0].toUpperCase();

    if (isUpperCaseA !== isUpperCaseB) {
      return isUpperCaseA ? -1 : 1;
    }

    return nameA.localeCompare(nameB);
  })}
  disableCloseOnSelect
  popupIcon={<KeyboardArrowDown />}
  limitTags={1}
  getOptionLabel={(option) =>
    `${option.FirstName} ${option.LastName}`
  }
  filterOptions={(options, { inputValue }) => {
    if (inputValue.trim() === "") {
      return options;
    }
    return options.filter((option) =>
      `${option.FirstName} ${option.LastName}`
        .toLowerCase()
        .includes(inputValue.toLowerCase())
    );
  }}
  onChange={handleSearchOnChange}
  value={selectedUsers}
  inputValue={searchInput} // Preserve search input
  onInputChange={(event, newInputValue, reason) => {
    if (reason !== "reset") {
      setSearchInput(newInputValue); // Prevent clearing when clicking outside
    }
  }}
  renderTags={() => null}
  renderOption={(props, option, { selected }) => {
    const isSelected = selectedUsers.some(
      (user) => user.UserId === option.UserId
    );
    return (
      <li {...props} key={option.UserId}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={isSelected}
          onChange={() =>
            handleSearchCheckboxOnChange(option, isSelected)
          }
        />
        <span className="select-option-text">
          {`${option.FirstName} ${option.LastName}`}
        </span>
      </li>
    );
  }}
  sx={{
    width: { xs: "100%", md: 300 },
    minWidth: { xs: "230px", md: "auto" },
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      variant="outlined"
      placeholder="Search Users"
    />
  )}
/>



                  <div style={{ marginTop: 3 }}>
                    {selectedUsers.map((option) => (
                      <Chip
                        key={option.UserId}
                        label={`${option.FirstName} ${option.LastName}`}
                        onDelete={() => {
                          handleSearchDeleteOnChange(option.UserId);
                        }}
                        style={{ margin: 5 }}
                      />
                    ))}
                  </div>

                  {/* <FormControl className="search-box" sx={{ m: 1, width: 300 }}>
                    <Select
                      labelId="demo-multiple-chip-label"
                      id="demo-multiple-chip"
                      multiple
                      value={personName}
                      onChange={handleChangeSearch}
                      input={<OutlinedInput id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                          {selected.map((customerId) => {
                            const customer = JSON.parse(userListSel).data.find(
                              (c) => c.UserId === customerId
                            );
                            return (
                              <Chip
                                key={customerId}
                                label={
                                  customer ? customer.UserName : customerId
                                }
                              />
                            );
                          })}
                        </div>
                      )}
                      MenuProps={MenuProps}
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="material-symbols-outlined">
                            search
                          </span>
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="start">
                          {personName && personName.length > 0 ? (
                            <IconButton
                              size="small"
                              aria-label="close"
                              color="inherit"
                              onClick={clearProject}
                            >
                              <HighlightOffIcon fontSize="small" />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </InputAdornment>
                      }
                    >
                      {userListSel &&
                        JSON.parse(userListSel).data.map((customer) => (
                          <MenuItem
                            key={customer.UserId}
                            value={customer.UserId}
                          >
                            <Checkbox
                              checked={personName.indexOf(customer.UserId) > -1}
                            />
                            <ListItemText primary={customer.UserName} />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl> */}
                </Grid>
                <Grid sx={{ mt: "auto", mb: "auto" }} xs={12} md={7}>
                  <Stack
                    spacing={1}
                    alignItems="center"
                    sx={{
                      float: { xs: "left", md: "right" },
                      alignItems: { xs: "flex-start", md: "center" },
                      marginTop: {
                        xs: "10px !important",
                        md: "0px !important",
                      },
                    }}
                    direction={{ xs: "column", sm: "row" }}
                  >
                    {usersFilter &&
                    (applyFilterFlag || selectedUsers.length > 0) &&
                    (typeof usersFilter.accountActive === "boolean" ||
                      usersFilter.accountActiveYes ||
                      usersFilter.accountActiveNo ||
                      usersFilter.userId ||
                      usersFilter.archivedUserStatus ||
                      selectedUsers.length > 0 ||
                      usersFilter.userRole) ? (
                      <Button
                        startIcon={
                          <span class="material-symbols-outlined">close</span>
                        }
                        className="clear-btn"
                        variant="contained"
                        // onClick={clearFilterOpen}
                        onClick={() => resetFilter(true)}
                      >
                        Clear Filter
                      </Button>
                    ) : (
                      ""
                    )}

                    <Stack
                      className="filter"
                      sx={{ float: "right", width: "90px" }}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      onClick={filterOpenFun}
                    >
                      <span class="material-symbols-outlined">filter_list</span>
                      <Typography>Filter</Typography>
                    </Stack>
                    <Link
                      to={{
                        pathname: USER_LOG_ROUTE,
                      }}
                      onClick={() => localStorageFilter(true)}
                    >
                      <Button
                        sx={{ width: "139px" }}
                        startIcon={
                          <span class="material-symbols-outlined">person</span>
                        }
                        className="secondary-btn"
                        variant="contained"
                      >
                        User History
                      </Button>
                    </Link>
                  </Stack>
                </Grid>
              </Grid>

              <Grid xs={12} md={12}>
                <TableContainer
                  sx={{
                    boxShadow: "none",
                    maxHeight: { xs: 440, md: 440, lg: 400, xl: 527 },
                  }}
                  component={Paper}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    // aria-label="simple table"
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        {/* <TableCell
                          sx={{ minWidth: { xs: "300px", md: "370px" } }}
                        > */}
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "FirstName"}
                            direction={orderBy === "FirstName" ? order : "asc"}
                            onClick={() => handleSortRequest("FirstName")}
                            IconComponent={() => getSortIcon("FirstName")}
                            style={
                              orderBy === "FirstName"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Name
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "Email"}
                            direction={orderBy === "Email" ? order : "asc"}
                            onClick={() => handleSortRequest("Email")}
                            IconComponent={() => getSortIcon("Email")}
                            style={
                              orderBy === "Email" ? { color: "#007fff" } : {}
                            }
                          >
                            Email
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sx={{ minWidth: "89px" }}>
                          User Role
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "PhoneNumber"}
                            direction={
                              orderBy === "PhoneNumber" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("PhoneNumber")}
                            IconComponent={() => getSortIcon("PhoneNumber")}
                            style={
                              orderBy === "PhoneNumber"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Phone Number
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "CreatedDate"}
                            direction={
                              orderBy === "CreatedDate" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("CreatedDate")}
                            IconComponent={() => getSortIcon("CreatedDate")}
                            style={
                              orderBy === "CreatedDate"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Created Date
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "AccountActive"}
                            direction={
                              orderBy === "AccountActive" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("AccountActive")}
                            IconComponent={() => getSortIcon("AccountActive")}
                            style={
                              orderBy === "AccountActive"
                                ? { color: "#007fff" }
                                : {}
                            }
                          >
                            Status
                          </TableSortLabel>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {loading && <CustomPageLoading />}
                    <TableBody>
                      {list &&
                        list.map((r) => {
                          const {
                            UserId,
                            FirstName,
                            LastName,
                            Email,
                            UserName,
                            PhoneNumber,
                            UserRole,
                            CreatedDate,
                            AccountActive,
                          } = r;
                          let acc = data.find((r1) => r1.id == r.UserId);
                          // var dataMoment = CreatedDate
                          //   ? moment(CreatedDate).format("MMMM Do YYYY, h:mm A")
                          //   : "";
                          const dataMoment = CreatedDate
                            ? moment
                                .utc(CreatedDate)
                                .format("MMMM Do YYYY, h:mm A")
                            : "";
                          return (
                            <TableRow
                              sx={{ minHeight: "60px", height: "60px" }}
                              component={Link}
                              to={{
                                pathname: `/user-details/${r.UserId}`,
                                state: { id: r.UserId },
                              }}
                              key={r.UserId}
                              onClick={() => localStorageFilter(true)}
                            >
                              {/* <Link
                                to={{
                                  pathname: `/user-details/${r.UserId}`,
                                  state: { id: r.UserId },
                                }}
                              > */}
                              <TableCell
                                sx={{ lineBreak: "anywhere" }}
                                scope="row"
                              >
                                {FirstName} {LastName}
                              </TableCell>
                              <TableCell>{Email}</TableCell>
                              <TableCell>
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                >
                                  {userRoleMapping(r.UserRole)}
                                </Stack>
                              </TableCell>
                              <TableCell sx={{ minWidth: "147px" }}>
                                {PhoneNumber}
                              </TableCell>
                              <TableCell sx={{ minWidth: "120px" }}>
                                {dataMoment}
                              </TableCell>
                              <TableCell sx={{ minWidth: "117px" }}>
                                <span
                                  className={
                                    AccountActive == 1
                                      ? "active-btn"
                                      : "inactive-btn"
                                  }
                                >
                                  {AccountActive == 1 ? "Active" : "Inactive"}
                                </span>
                              </TableCell>
                              {/* </Link> */}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                  <br />
                </TableContainer>
                {!loading && list && list.length == 0 ? (
                  <NoRecordFound />
                ) : (
                  <></>
                )}
                {!loading && total > 0 && (
                  <Pagination
                    sx={{ mt: "15px", float: "right" }}
                    shape="rounded"
                    // hidePrevButton
                    // hideNextButton
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          previous: () => (
                            <Icon className="material-symbols-outlined">
                              keyboard_backspace
                            </Icon>
                          ),
                          next: () => (
                            <Icon className="material-symbols-outlined">
                              east
                            </Icon>
                          ),
                        }}
                        {...item}
                      />
                    )}
                    count={total}
                    page={page + 1}
                    onChange={handleChange}
                  />
                )}
                {openFilter && (
                  <UserFilter
                    open={openFilter}
                    handleClose={filterClose}
                    filterValue={usersFilter}
                    setFilterValue={setUsersFilter}
                    applyFilterFun={applyFilterFun}
                    isOnlyAdmin={isOnlyAdmin}
                  />
                )}

                {clearFlag && (
                  <UserClearFilter
                    open={clearFlag}
                    clearFiltervalue={clearFiltervalue}
                    setClearFilterValue={setClearFilterValue}
                    resetFilter={resetFilter}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Users;
